// extracted by mini-css-extract-plugin
export default {"meeoppEditorWrapper":"_2dxIK","meeoppEditor":"_2QLdn","editorWithoutPlaceholder":"_2SGJf","editorToolbarIcon":"_345HP"};